import { useQuery } from "@tanstack/react-query"
import { searchPassportReports } from "../api/reports"

export const useSearchPassportReportsQuery = (params) => {
  return useQuery({
    queryKey: ["searchPassportReports", params],
    queryFn: () => searchPassportReports(params),
  })
}